<template>
  <div id="contentEdit">
    <div class="title">{{ contentName }}</div>
    <el-input v-model="content" type="textarea"></el-input>
    <div class="buttonBox">
      <el-button type="primary" @click="saveContent(content)">保存</el-button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      content: "",
      contentName: "",
      contentBefore: "",
      isure: 10,
    };
  },
  mounted() {
    let that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    $.ajax({
      url: "/zyk/word/preview",
      type: "GET",
      dataType: "json",
      data: { id: localStorage.getItem("wordId") },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.reload();
        }
      },
      success: function (data) {
        if (data.code == 200) {
          that.content = data.obj.content;
          that.contentBefore = data.obj.content;
          that.contentName = data.obj.name;
        } else {
          that.$message({
            message: data.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
    });
  },
  methods: {
    saveContent(content) {
      console.log(content);
      let that = this;
      //   if (content == this.contentBefore) {
      //     that.isure = 10;
      //   } else {
      //     that.isure = 20;
      //   }
      $.ajax({
        url: "/zyk/word/updateContent",
        type: "POST",
        dataType: "json",
        data: {
          wordId: localStorage.getItem("wordId"),
          content: content,
          isure: this.isure,
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "修改成功",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.content = data.obj.content;
            that.contentName = data.obj.name;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
  },
};
</script>

<style>
#contentEdit {
  padding: 20px 15%;
}

.title {
  text-align: center;
  margin: 10px 0 30px 0;
  font-size: 30px;
  font-weight: bolder;
}
#contentEdit .el-textarea__inner {
  height: 80vh;
  line-height: 2.5em;
  font-size: 16px;
}
.buttonBox {
  margin-top: 20px;
  text-align: right;
}
</style>